import script from "./NapLotadaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NapLotadaForm.vue?vue&type=script&setup=true&lang=js"

import "./NapLotadaForm.vue?vue&type=style&index=0&id=100e7548&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100e7548"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput});
